import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import {EMAIL_NOT_FOUND_TYPE} from '@app/shared';
import {PasswordResetInitService} from '@app/account/password-reset/init/password-reset-init.service';
import {isPlatformBrowser} from '@angular/common';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-password-reset-init',
  templateUrl: './password-reset-init.component.html',
  styleUrls: ['./password-reset-init.scss'],
})
export class PasswordResetInitComponent implements OnInit, AfterViewInit {
  error: string;
  errorEmailNotExists: string;
  resetAccount: any;
  success: string;

  constructor(
    private passwordResetInitService: PasswordResetInitService,
    private elementRef: ElementRef,
    private titleService: Title,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('account.password-reset.init.Quên mật khẩu_title'),
    );
    this.resetAccount = {};
  }

  ngAfterViewInit() {
    // this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    const eleRef = this.elementRef.nativeElement.querySelector('#email');
    if (isPlatformBrowser(this.platformId)) {
      eleRef.nativeElement['focus']();
    }
  }

  requestReset() {
    this.error = null;
    this.errorEmailNotExists = null;

    this.passwordResetInitService.save(this.resetAccount.email).subscribe(
      () => {
        this.success = 'OK';
      },
      (response) => {
        this.success = null;
        if (
          response.status === 400 &&
          response.error.type === EMAIL_NOT_FOUND_TYPE
        ) {
          this.errorEmailNotExists = 'ERROR';
        } else {
          this.error = 'ERROR';
        }
      },
    );
  }
}
